import React, { useState, useEffect } from "react";
import {
  resolveLastUpdated,
  describeAge,
  useAgeTicker,
} from "../../../util/CameraAgeUtil";

const FeaturedCamera = ({ camera }) => {
  const [refreshKey, setRefreshKey] = useState(Date.now());
  useAgeTicker(1000);

  // Auto-refresh the snapshot every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => setRefreshKey(Date.now()), 30000);
    return () => clearInterval(interval);
  }, []);

  if (!camera) return null;

  const props = camera.properties;
  const encodedId = encodeURIComponent(props.id);
  const isRemote = props.remUrls && props.remUrls.length > 0;
  const imgSrc = isRemote
    ? props.remUrls[0]
    : `/lmiga/snapshot?id=${encodedId}&_t=${refreshKey}`;

  const handleImageClick = () => {
    const fullSrc = isRemote ? imgSrc : `/lmiga/snapshot?id=${encodedId}`;
    window.open(fullSrc, "_blank", "width=800,height=600");
  };

  return (
    <div className="space-y-2">
      <div className="text-sm">
        <span className="font-medium">{props.locDesc}</span>
        {props.src && (
          <span className="text-muted-foreground"> ({props.src})</span>
        )}
      </div>
      <div className="text-xs text-muted-foreground">
        Last Updated: {describeAge(resolveLastUpdated(props)).text}
      </div>
      <img
        src={imgSrc}
        alt={props.locDesc || "Camera snapshot"}
        className="w-full rounded cursor-pointer"
        style={{ maxHeight: 200, objectFit: "contain" }}
        onClick={handleImageClick}
        referrerPolicy={
          isRemote && imgSrc.includes("cctv.travelmidwest.com")
            ? "origin"
            : isRemote
              ? "no-referrer"
              : undefined
        }
      />
    </div>
  );
};

export default FeaturedCamera;
